// Fixture rows are authored in the app's parsed shape (snake_case keys, amounts
// in CENTS) because that is what the demo scenarios reason about — but fixtures
// feed the network seam, so they must speak the wire. This is the fixtures'
// inverse of parseLimitStatuses.

type LimitsFixtureRow = Record<string, unknown> & {
  employee_id: string;
  available: number | null;
  available_with_override: number | null;
};

function dasherizeKeysDeep(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(dasherizeKeysDeep);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, inner]) => [
        key.replace(/_/g, '-'),
        dasherizeKeysDeep(inner),
      ])
    );
  }
  return value;
}

/**
 * Wraps limits fixture rows into the contract-2 wire document
 * GET /api/v2/limits/status serves: JSON:API resources under `data`, attribute
 * keys dasherized at every level, `available`/`available_with_override` as
 * two-decimal money strings, and the employee id as the resource id.
 */
export function limitsStatusContract2Document(rows: LimitsFixtureRow[]) {
  return {
    data: rows.map((row) => {
      const { available, available_with_override, ...rest } = row;
      return {
        id: row.employee_id,
        type: 'limit-statuses',
        attributes: dasherizeKeysDeep({
          ...rest,
          available: available === null ? null : available.toFixed(2),
          available_with_override:
            available_with_override === null ? null : available_with_override.toFixed(2),
        }),
      };
    }),
  };
}
